import { AreaUnit, PricingPlan } from '../../graphql/graphql';
import { Plan } from '../constants/plans';

export const getAnnualPlanCheckoutLink = (
  areaUnit: AreaUnit,
  area: string,
  userSeats: string,
  planetImagery: string,
) => {
  const searchParams = new URLSearchParams({
    plan: Plan.annual,
    areaUnit,
    area,
    userSeats,
    planetImagery,
  });

  return `${import.meta.env.VITE_CHECKOUT_URL}?${searchParams.toString()}`;
};

export const getMonthlyPlanCheckoutLink = (areaUnit: AreaUnit) => {
  const searchParams = new URLSearchParams({
    plan: Plan.monthly,
    areaUnit,
  });

  return `${import.meta.env.VITE_CHECKOUT_URL}?${searchParams.toString()}`;
};

export const readPlanParam = (searchParams: URLSearchParams) =>
  searchParams.get('plan');

export const readAreaUnitParam = (searchParams: URLSearchParams) =>
  searchParams.get('areaUnit');

export const readAreaParam = (searchParams: URLSearchParams) =>
  searchParams.get('area');

export const readUserSeatsParam = (searchParams: URLSearchParams) =>
  searchParams.get('userSeats');

export const readPlanetImageryParam = (searchParams: URLSearchParams) =>
  searchParams.get('planetImagery');

export const getReturnUrl = (
  plan: PricingPlan,
  stripeCustomerId?: string | null,
) => {
  const params = new URLSearchParams({ plan });

  if (stripeCustomerId) {
    params.append('customerId', stripeCustomerId);
  }

  return `${import.meta.env.VITE_STRIPE_RETURN_URL}?${params.toString()}`;
};
